/* ReliefPaws theme JS
   Ported from the static index.html. The fake cart drawer has been replaced with a
   real Shopify product form (id="product-form") that AJAX-posts to /cart/add.js,
   updates the header cart count, and shows a success modal. Everything else
   (gallery, qty stepper price sync, purchase-option selection, reviews module,
   sticky mobile bar, jar 3D tilt, header scrolled class) is preserved. */
(function(){
  'use strict';

  var form = document.getElementById('product-form');

  /* ---------- money ---------- */
  function money(cents){
    var cur = (form && form.getAttribute('data-currency')) || 'USD';
    var n = (parseInt(cents,10)||0)/100;
    try { return n.toLocaleString('en-US',{style:'currency',currency:cur}); }
    catch(e){ return '$'+n.toFixed(2); }
  }

  /* ---------- qty ---------- */
  var qEl = document.getElementById('qVal');
  function qty(){ return Math.max(1, parseInt(qEl && qEl.value,10)||1); }

  /* ---------- purchase option + price sync ---------- */
  function selectedRadio(){ return document.querySelector('#product-form input[name=id]:checked'); }
  function unitCents(){
    var r = selectedRadio();
    if(r && r.getAttribute('data-price')) return parseInt(r.getAttribute('data-price'),10)||0;
    if(form && form.getAttribute('data-price')) return parseInt(form.getAttribute('data-price'),10)||0;
    return 0;
  }
  function addonCents(){ var a=document.getElementById('addonCb'); return (a && a.checked) ? (parseInt(a.getAttribute('data-price'),10)||0) : 0; }
  function syncPrice(){
    var cents = unitCents(), q = qty(), r = selectedRadio();
    var atcPrice = document.getElementById('atcPrice');
    if(atcPrice) atcPrice.textContent = money(cents*q + addonCents());
    var atcNote = document.getElementById('atcNote');
    var note = (r && r.getAttribute('data-note')) || (form && form.getAttribute('data-note')) || '';
    if(atcNote && note) atcNote.innerHTML = note;
    var stickySp = document.getElementById('stickySp');
    if(stickySp){
      var lbl = (r && r.getAttribute('data-short')) || (form && form.getAttribute('data-short')) || '';
      stickySp.innerHTML = money(cents*q + addonCents()) + (lbl ? '<small>'+lbl+'</small>' : '');
    }
  }

  var aoEl = document.getElementById('addonCb'); if(aoEl) aoEl.addEventListener('change', function(){ syncPrice(); });
  /* purchase-option selection (.sel highlight) */
  document.querySelectorAll('#product-form input[name=id]').forEach(function(radio){
    radio.addEventListener('input', function(){
      document.querySelectorAll('#product-form .opt').forEach(function(o){ o.classList.remove('sel'); });
      var opt = radio.closest('.opt'); if(opt) opt.classList.add('sel');
      syncPrice();
    });
  });

  /* ---------- order bump ----------
     Ticking it selects the next pack size up rather than adding a separate line item, so the
     price shown is always a real variant price and it survives any future price change. */
  (function(){
    var row = document.getElementById('bumpRow'),
        box = document.getElementById('bumpBox'),
        ttl = document.getElementById('bumpTitle');
    if(!row || !box || !ttl) return;
    var ORD = {2:'second',3:'third',4:'fourth',5:'fifth',6:'sixth'};
    var fromId = null;
    function radios(){ return Array.prototype.slice.call(document.querySelectorAll('#product-form input[name=id]')); }
    function cents(r){ return parseInt(r && r.getAttribute('data-price'),10) || 0; }
    function pick(r){
      radios().forEach(function(x){ x.checked = (x === r); });
      document.querySelectorAll('#product-form .opt').forEach(function(o){ o.classList.remove('sel'); });
      var o = r.closest('.opt'); if(o) o.classList.add('sel');
      syncPrice();
    }
    function refresh(){
      var rs = radios(), cur = selectedRadio();
      if(!cur){ row.hidden = true; return; }
      if(box.checked){ row.hidden = false; return; }   // stay visible so it can be undone
      var next = rs[rs.indexOf(cur) + 1];
      if(!next || next.disabled){ row.hidden = true; return; }
      var delta = cents(next) - cents(cur);
      if(delta <= 0){ row.hidden = true; return; }
      var jars = parseInt(next.getAttribute('data-jars'), 10) || (rs.indexOf(next) + 1);
      ttl.textContent = 'Add a ' + (ORD[jars] || (jars + 'th')) + ' jar for ' + money(delta);
      row.hidden = false;
    }
    box.addEventListener('change', function(){
      var rs = radios(), cur = selectedRadio();
      if(box.checked){
        var next = rs[rs.indexOf(cur) + 1];
        if(next){ fromId = cur.value; pick(next); } else { box.checked = false; }
      } else {
        var back = null;
        rs.forEach(function(x){ if(x.value === fromId) back = x; });
        if(back) pick(back);
        fromId = null;
      }
      refresh();
    });
    radios().forEach(function(r){
      r.addEventListener('change', function(){
        if(box.checked){ box.checked = false; fromId = null; }
        refresh();
      });
    });
    refresh();
  })();

  /* qty stepper */
  var qMinus = document.getElementById('qMinus'), qPlus = document.getElementById('qPlus');
  if(qMinus) qMinus.onclick = function(){ if(qEl){ qEl.value = Math.max(1, qty()-1); } syncPrice(); };
  if(qPlus)  qPlus.onclick  = function(){ if(qEl){ qEl.value = qty()+1; } syncPrice(); };
  if(qEl) qEl.addEventListener('input', syncPrice);
  syncPrice(); // sync Add-to-Cart price to the default-selected pack on load

  /* ---------- gallery ---------- */
  var gThumbs = Array.prototype.slice.call(document.querySelectorAll('#thumbs .thumb'));
  var gSlides = Array.prototype.slice.call(document.querySelectorAll('.main-view .slide'));
  var gIndex = 0;
  function goSlide(i){
    if(!gSlides.length) return;
    gIndex = (i + gSlides.length) % gSlides.length;
    gThumbs.forEach(function(x){ x.classList.toggle('active', x.getAttribute('data-go') == String(gIndex)); });
    gSlides.forEach(function(s){ s.classList.toggle('active', s.getAttribute('data-slide') == String(gIndex)); });
    fitFrame();
  }
  // Resize the gallery frame to the active image's exact ratio so nothing ever letterboxes (jar is portrait, infographics are square).
  function fitFrame(){
    var mvF = document.querySelector('.main-view'); if(!mvF) return;
    var s = gSlides[gIndex]; if(!s) return;
    var im = s.querySelector('img'); if(!im){ mvF.style.aspectRatio = ''; return; }
    function apply(){ if(im.naturalWidth && im.naturalHeight){ mvF.style.aspectRatio = im.naturalWidth + ' / ' + im.naturalHeight; } }
    if(im.complete && im.naturalWidth){ apply(); } else { im.addEventListener('load', apply, {once:true}); }
  }
  gThumbs.forEach(function(t){ t.onclick = function(){ goSlide(parseInt(t.getAttribute('data-go'))); }; });
  var gp = document.getElementById('gPrev'), gn = document.getElementById('gNext');
  if(gp) gp.onclick = function(){ goSlide(gIndex - 1); };
  if(gn) gn.onclick = function(){ goSlide(gIndex + 1); };
  fitFrame();
  (function(){
    var mv = document.querySelector('.main-view'); if(!mv) return;
    var x0 = null;
    mv.addEventListener('touchstart', function(e){ x0 = e.changedTouches[0].clientX; }, {passive:true});
    mv.addEventListener('touchend', function(e){
      if(x0 === null) return; var dx = e.changedTouches[0].clientX - x0;
      if(Math.abs(dx) > 40) goSlide(gIndex + (dx < 0 ? 1 : -1));
      x0 = null;
    }, {passive:true});
  })();

  /* ---------- add to cart (real Shopify) ---------- */
  function updateCartCount(count){
    var el = document.getElementById('cartCount');
    if(!el) return;
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  }
  function openModal(){
    var m = document.getElementById('cartModal');
    if(m){ m.classList.add('show'); m.setAttribute('aria-hidden','false'); }
    document.body.classList.add('lock');
  }
  function closeModal(){
    var m = document.getElementById('cartModal');
    if(m){ m.classList.remove('show'); m.setAttribute('aria-hidden','true'); }
    document.body.classList.remove('lock');
  }
  if(form){
    form.addEventListener('submit', function(e){
      if(!window.fetch) return; // no fetch → let Shopify handle the native POST
      e.preventDefault();
      var btns = [].slice.call(document.querySelectorAll('#product-form [name=add], [form="product-form"][name=add]'));
      var data = new FormData(form);
      var ao = document.getElementById('addonCb');
      if(ao && ao.checked){
        var main = data.get('id'), mq = parseInt(data.get('quantity'),10)||1;
        data = JSON.stringify({ items:[ { id: parseInt(main,10), quantity: mq }, { id: parseInt(ao.getAttribute('data-vid'),10), quantity: 1 } ] });
      }
      btns.forEach(function(b){ if(!b.getAttribute('data-label')) b.setAttribute('data-label', b.innerHTML); b.disabled = true; b.classList.add('is-adding'); b.innerHTML = 'Adding…'; });
      var hdrs = { 'Accept':'application/json' }; if(typeof data === 'string') hdrs['Content-Type'] = 'application/json';
      fetch('/cart/add.js', { method:'POST', headers:hdrs, body:data })
        .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function(){ window.location.href = '/cart'; })  // go straight to the cart page
        .catch(function(){ form.submit(); }); // fall back to native post (also lands on /cart)
    });
    /* Back from /cart restores the page from bfcache with the button still disabled. Reset it. */
    function resetAdd(){
      document.querySelectorAll('#product-form [name=add], [form="product-form"][name=add]').forEach(function(b){
        var l = b.getAttribute('data-label'); if(l){ b.innerHTML = l; }
        b.disabled = false; b.classList.remove('is-adding');
      });
      syncPrice();
    }
    window.addEventListener('pageshow', function(e){ if(e.persisted) resetAdd(); });
  }
  document.querySelectorAll('[data-modal-close]').forEach(function(b){ b.onclick = closeModal; });
  var modalEl = document.getElementById('cartModal');
  if(modalEl) modalEl.addEventListener('click', function(e){ if(e.target === modalEl) closeModal(); });

  /* ---------- mobile menu ---------- */
  var overlay = document.getElementById('overlay');
  function closeMenu(){
    var mm = document.getElementById('mobileMenu'); if(mm) mm.classList.remove('open');
    if(overlay) overlay.classList.remove('show');
    document.body.classList.remove('lock');
  }
  var burger = document.getElementById('burger');
  if(burger) burger.onclick = function(){
    var mm = document.getElementById('mobileMenu'); if(mm) mm.classList.add('open');
    if(overlay) overlay.classList.add('show');
    document.body.classList.add('lock');
  };
  var mmClose = document.getElementById('mmClose');
  if(mmClose) mmClose.onclick = closeMenu;
  if(overlay) overlay.onclick = closeMenu;
  document.querySelectorAll('#mobileMenu a').forEach(function(a){ a.onclick = closeMenu; });

  /* ---------- header shadow + sticky buy ---------- */
  window.addEventListener('scroll', function(){
    var h = document.getElementById('header'); if(h) h.classList.toggle('scrolled', window.scrollY > 10);
    /* 560 meant price and Add to Cart were invisible on landing and for the first two thirds of a
       phone screen. 160 surfaces the offer on the first scroll without covering the title on load. */
    var sb = document.getElementById('stickyBuy'); if(sb) sb.classList.toggle('show', window.scrollY > 160);
  });

  /* ---------- jar 3D tilt ---------- */
  var jar = document.getElementById('jar3d'), stage = jar && jar.closest('.main-view');
  if(stage){
    stage.addEventListener('mousemove', function(e){
      var rct = stage.getBoundingClientRect();
      var x = (e.clientX-rct.left)/rct.width-.5, y = (e.clientY-rct.top)/rct.height-.5;
      jar.style.transform = 'rotateY('+(x*16)+'deg) rotateX('+(-y*12)+'deg)';
    });
    stage.addEventListener('mouseleave', function(){ jar.style.transform=''; });
  }

  syncPrice();

  /* ================= REVIEWS =================
     ⚠ PLACEHOLDER DATA — replace this array with real verified reviews (Loox / Judge.me)
     before you sell. Do not publish invented reviews as genuine. */
  var REVIEWS=[
    {name:"Maria G.",date:"1 week ago",r:5,verified:true,photo:true,img:"frenchie",helpful:34,title:"Finally settling at night",body:"We adopted Cooper three weeks ago and he paced until 2am every night. About ten days in he actually settled on his bed. Not knocked out — just calmer."},
    {name:"Devin R.",date:"1 week ago",r:5,verified:true,photo:true,img:"devin",helpful:21,title:"Loved that I could read the label",body:"Bought a different brand first that hid everything in a 'proprietary blend.' Being able to see the actual amounts sold me. Bonus: no chicken, since mine has allergies."},
    {name:"Priya S.",date:"2 weeks ago",r:4,verified:true,photo:false,helpful:12,title:"Took about two weeks",body:"Wasn't overnight like I hoped, but by week two the whining when I leave for work is way down. Sticking with the subscription."},
    {name:"Bianca R.",date:"2 weeks ago",r:5,verified:true,photo:true,img:"bianca",helpful:26,title:"Crate training got so much easier",body:"She used to bark the entire time in her crate. One chew before bed and she actually settles now. Two weeks in and it keeps getting better."},
    {name:"Marcus T.",date:"2 weeks ago",r:5,verified:true,photo:true,helpful:28,title:"Fireworks weren't a nightmare this year",body:"First July we didn't spend the night under the bed. Gave it about 45 minutes before and she was so much more relaxed."},
    {name:"Tommy V.",date:"3 weeks ago",r:5,verified:true,photo:false,helpful:17,title:"No more shredded blinds",body:"Years of destroyed blinds and chewed door frames when I left. Gave this a real month plus more walks and the destruction basically stopped."},
    {name:"Jenna L.",date:"3 weeks ago",r:5,verified:true,photo:true,img:"jenna",helpful:9,title:"My picky rescue actually eats it",body:"He spits out most chews. Ate this one like a treat. Small thing, but a huge deal for us."},
    {name:"Grace L.",date:"3 weeks ago",r:5,verified:true,photo:true,helpful:31,title:"Car rides without the shaking",body:"He used to drool and shake the whole drive. Now he curls up in the back seat. Road trips are finally something we can do."},
    {name:"Aaron K.",date:"4 weeks ago",r:5,verified:true,photo:false,helpful:15,title:"Clean ingredients I actually trust",body:"Did my research — most calming chews are mostly filler. This one's genuinely clean and every dose is printed. Feels good knowing exactly what he's getting."},
    {name:"Omar S.",date:"1 month ago",r:5,verified:true,photo:false,helpful:14,title:"The peanut butter flavor is clutch",body:"My guy is impossible with pills. This one he thinks is a treat and comes running for it. Half the battle right there."},
    {name:"Sofia M.",date:"1 month ago",r:4,verified:true,photo:false,helpful:7,title:"Good before vet visits",body:"Give it before appointments and grooming and he's noticeably less shaky. Wish the jar was a little bigger for my big guy."},
    {name:"Derek M.",date:"1 month ago",r:5,verified:true,photo:true,helpful:44,title:"Our shelter pup finally exhaled",body:"The first few weeks home he was a nervous wreck. This plus patience and he's a completely different dog on the couch now. Thank you for making something honest.",reply:"Made our whole day, Derek. Give him a scratch from the ReliefPaws team."},
    {name:"Lauren K.",date:"1 month ago",r:4,verified:true,photo:false,helpful:10,title:"Helps, but give it time",body:"Not a magic switch — it took about 12 days before I really noticed. Now the pacing before I leave is way calmer. Glad I didn't quit early."},
    {name:"Nina P.",date:"1 month ago",r:5,verified:true,photo:false,helpful:22,title:"My vet was actually on board",body:"I brought the label to our vet since it lists every amount. She said the ingredients made sense and had no concerns. That transparency won me over."},
    {name:"Ryan P.",date:"2 months ago",r:5,verified:true,photo:true,img:"maria",helpful:41,title:"Helped our newly-adopted girl settle",body:"The first two weeks home were rough. This plus a real routine made a difference. She's finally relaxing on the couch instead of by the door.",reply:"This is exactly why we made it, Ryan — so glad she's settling in."},
    {name:"Cody B.",date:"2 months ago",r:5,verified:true,photo:false,helpful:18,title:"Thunderstorms don't wreck the night",body:"We get brutal storms here and he used to claw at the door. Give it 45 minutes before it rolls in and he just deals with it now."},
    {name:"Hannah B.",date:"2 months ago",r:5,verified:true,photo:false,helpful:19,title:"Relaxed, not sedated",body:"Was worried it'd make him drowsy, but it just takes the edge off in the evening. He's still himself, only calmer."},
    {name:"Shawna T.",date:"2 months ago",r:5,verified:true,photo:true,helpful:29,title:"Rescue anxiety, meet your match",body:"Adopted a senior who'd clearly been through it. Six weeks of these plus routine and he finally trusts that the house is his."},
    {name:"Diego F.",date:"2 months ago",r:5,verified:true,photo:false,helpful:6,title:"Subscription is actually easy",body:"Shows up every month, and I skipped one delivery with a single click. No games, no phone calls to cancel anything."},
    {name:"Emily D.",date:"2 months ago",r:3,verified:true,photo:false,helpful:8,title:"Works for her, not as much for him",body:"Honestly mixed — my anxious girl calmed down nicely, but my bigger boy needed the full 3 chews to notice much. Still using it, just wish it were a bit stronger per chew."},
    {name:"Chloe W.",date:"3 months ago",r:4,verified:true,photo:false,helpful:5,title:"Solid for storm season",body:"Takes his thunder anxiety down a notch. Not magic on its own, but pairs really well with a thundershirt and a quiet room."},
    {name:"Miguel A.",date:"3 months ago",r:5,verified:true,photo:false,helpful:16,title:"Cancelled my old brand for this",body:"Was paying more for a chew that hid its doses. Switched, saw a bigger difference, and managing the subscription is genuinely one click."},
    {name:"Paul H.",date:"3 months ago",r:5,verified:true,photo:true,helpful:33,title:"Grooming stopped being a battle",body:"Used to take two people to hold him. One chew beforehand and the groomer said he was the calmest he's ever been. Huge for us."},
    {name:"Renata C.",date:"3 months ago",r:5,verified:true,photo:false,helpful:11,title:"The whole family noticed",body:"Even my kids said the dog seems happier. He's not zoned out — just not glued to the window barking at everything anymore."},
    {name:"Nate H.",date:"4 months ago",r:5,verified:true,photo:true,helpful:23,title:"Wish I'd found this sooner",body:"Three years of trying things for our anxious shepherd. First one that made a visible difference in his day-to-day."}
  ];
  var PER=5, sortKey='recent', curPage=1;

  function starStr(n){return '★★★★★☆☆☆☆☆'.slice(5-n,10-n);}
  function rpImg(x){return (x.img&&window.RP_REVIEW_IMGS&&window.RP_REVIEW_IMGS[x.img])||null;}
  // The strip renders these at ~106px but the source files are 1000px, so each thumbnail was
  // pulling ~86KB to show 8KB worth of pixels. Shopify's CDN resizes theme assets via &width.
  function rpThumb(x){var u=rpImg(x); return u ? u+(u.indexOf('?')>-1?'&':'?')+'width=220' : null;}
  function reviewCard(x){
    return '<div class="review"><div class="top"><div class="av">'+x.name.charAt(0)+'</div>'
      +'<div class="who"><div class="nm">'+x.name+(x.verified?' <span class="vb">✓ Verified</span>':'')+'</div><div class="date">'+x.date+'</div></div>'
      +'<div class="rstars">'+starStr(x.r)+'</div></div>'
      +'<div class="rt">'+x.title+'</div><div class="rb">'+x.body+'</div>'
      +(rpImg(x)?('<div class="rphoto has-img"><img src="'+rpImg(x)+'" alt="'+x.name+' — customer photo" loading="lazy"></div>'):'')
      +'<div class="rfoot"><button type="button">Helpful ('+x.helpful+')</button></div>'
      +(x.reply?'<div class="reply"><b>ReliefPaws</b> replied: '+x.reply+'</div>':'')
      +'</div>';
  }
  function sortedList(){
    var l=REVIEWS.slice();
    if(sortKey==='high') l.sort(function(a,b){return b.r-a.r;});
    else if(sortKey==='photos') l=l.filter(function(x){return rpImg(x);});
    return l;
  }
  function renderReviews(){
    if(!document.getElementById('revAvg')) return;
    var full=REVIEWS, avg=(full.reduce(function(s,x){return s+x.r;},0)/full.length).toFixed(1);
    document.getElementById('revAvg').textContent=avg;
    document.getElementById('revStarsFill').style.width=(avg/5*100)+'%';
    document.getElementById('revCnt').textContent='Based on '+full.length+' reviews';
    // breakdown bars
    var dist=[0,0,0,0,0]; full.forEach(function(x){dist[x.r-1]++;});
    var bars=''; for(var s=5;s>=1;s--){var pct=Math.round(dist[s-1]/full.length*100);
      bars+='<div class="barrow"><span class="lab">'+s+' ★</span><span class="track"><span class="fill" style="width:'+pct+'%"></span></span><span class="n">'+dist[s-1]+'</span></div>';}
    document.getElementById('revBars').innerHTML=bars;
    // customer photo strip
    var ph=''; full.filter(function(x){return rpImg(x);}).forEach(function(x){ph+='<div class="rp has-img"><img src="'+rpThumb(x)+'" alt="Customer photo" loading="lazy" decoding="async"></div>';});
    document.getElementById('revPhotos').innerHTML=ph;
    // pages
    var list=sortedList();
    document.getElementById('revToolCnt').textContent=(sortKey==='photos'?list.length+' reviews with photos':full.length+' reviews');
    var pages=Math.max(1,Math.ceil(list.length/PER));
    if(curPage>pages)curPage=1;
    var wrap=document.getElementById('revPages'); wrap.innerHTML='';
    for(var p=0;p<pages;p++){
      var pg=document.createElement('div');
      pg.className='rev-page'+((p+1)===curPage?' active':'');
      pg.setAttribute('data-p',p+1);
      pg.innerHTML=list.slice(p*PER,p*PER+PER).map(reviewCard).join('');
      wrap.appendChild(pg);
    }
    renderPager(pages);
  }
  function renderPager(pages){
    var pg=document.getElementById('revPager');
    if(!pg) return;
    if(pages<=1){pg.innerHTML='';return;}
    var html='<button type="button" class="nav" data-nav="prev"'+(curPage<=1?' disabled':'')+'>‹<span class="navtxt">&nbsp;Prev</span></button>';
    for(var i=1;i<=pages;i++) html+='<button type="button" class="'+(i===curPage?'active':'')+'" data-go="'+i+'">'+i+'</button>';
    html+='<button type="button" class="nav" data-nav="next"'+(curPage>=pages?' disabled':'')+'><span class="navtxt">Next&nbsp;</span>›</button>';
    pg.innerHTML=html;
    pg.querySelectorAll('button').forEach(function(b){
      b.onclick=function(){
        if(b.dataset.go) curPage=parseInt(b.dataset.go);
        else if(b.dataset.nav==='prev') curPage=Math.max(1,curPage-1);
        else curPage=Math.min(pages,curPage+1);
        renderReviews();
        document.getElementById('reviews').scrollIntoView({behavior:'smooth',block:'start'});
      };
    });
  }
  var revSort=document.getElementById('revSort');
  if(revSort) revSort.onchange=function(){sortKey=this.value;curPage=1;renderReviews();};
  var writeBtn=document.getElementById('writeBtn');
  if(writeBtn) writeBtn.onclick=function(){this.textContent='Reviews open after your first order';this.disabled=true;this.style.opacity=.75;};
  renderReviews();
})();

/* Videos start with preload="none" so they cost nothing on first paint.
   Load and play each one just before it scrolls into view, pause it when it
   leaves, so a phone on cell data never pulls 2.4MB it may not scroll to. */
(function(){
  var vids = document.querySelectorAll('video[data-lazyvid]');
  if (!vids.length) return;
  if (!('IntersectionObserver' in window)) {
    vids.forEach(function(v){ v.preload = 'auto'; v.play().catch(function(){}); });
    return;
  }
  var warm = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (!e.isIntersecting) return;
      var v = e.target;
      if (v.preload !== 'auto') { v.preload = 'auto'; v.load(); }
      warm.unobserve(v);
    });
  }, { rootMargin: '600px 0px' });

  var play = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      var v = e.target;
      if (e.isIntersecting) { v.play().catch(function(){}); }
      else if (!v.paused) { v.pause(); }
    });
  }, { threshold: 0.2 });

  vids.forEach(function(v){ warm.observe(v); play.observe(v); });
})();
